import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OdometerNumber } from '../odometer-number/odometer-number.';

@Component({
  selector: 'fz-event-number',
  standalone: true,
  imports: [OdometerNumber, MatTooltipModule],
  templateUrl: './event-number.html',
  styleUrls: ['./event-number.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-event-number',
  },
})
export class EventNumber {
  eventCode = input.required<string>();

  prefix = computed(() => {
    const eventCode = this.eventCode();

    if (eventCode) {
      const prefix = eventCode.replace(/[0-9]/g, '');

      return prefix;
    }

    return '';
  });

  numbers = computed(() => {
    const eventCode = this.eventCode();

    if (eventCode) {
      const numbers = eventCode.replace(/[a-zA-Z]/g, '');

      return numbers.split('');
    }
    return [];
  });
}
